import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { useNavigate } from "react-router-dom";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { toast } from "react-toastify";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { useDispatch, useSelector } from "react-redux";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const UserSucess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const services = useSelector((state) => state.refreshToken.services);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!state) {
      navigate("/home", { replace: true });
    }
  }, [navigate, state]);

  function capitalizeWords(str) {
    return str
      ? str
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "";
  }

  const roleStr = state?.user?.newRoles
    ?.map((val) => {
      return val?.value;
    })
    ?.join(",");

  const tagStr = state?.user?.newTags
    ?.map((val) => {
      return val?.value;
    })
    ?.join(",");

  const buttonRows = [
    [
      {
        btnText: "Create new user",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: () => {
          navigate("/settings/users/create_user");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () => {
          if (services.includes("Admin")) {
            navigate(
              `/settings/user_view_all/user_detail_page/${state?.user?.employees[0]?.id}`,
            );
          } else {
            toast.info("Coming soon!", toast_position);
          }
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: () => {
          navigate("/home");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  const buttonRows2 = [
    [
      {
        btnText: "Create new user",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: () => {
          navigate("/settings/users/create_user");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: () => {
          navigate("/home");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        isLoading={false}
        status="success"
        hoverOption="white"
        title={" User created successfully. "}
        buttonRows={services?.includes("Admin") ? buttonRows : buttonRows2}
      >
        <TabsWeapperSection title="User details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              s
              rows={[
                {
                  leftTitle: capitalizeWords(
                    state?.user?.employees[0]?.first_name,
                  ),
                  leftSubTitle: "User name",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: state?.user?.employees[0]?.mob_no,
                  leftSubTitle: "Contact number",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: state?.user?.employees[0]?.user_id,
                  leftSubTitle: "User ID",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: capitalizeWords(
                    state?.user?.employees[0]?.alias_name,
                  ),
                  leftSubTitle: "Alias",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: state?.user?.employees[0]?.email_id,
                  leftSubTitle: "Email ID",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: state?.user?.employees[0]?.grade,
                  leftSubTitle: "Grade",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: state?.user?.pan,
                  leftSubTitle: "Pan number",
                },
              ]}
            />
            {state?.user?.newRoles?.length > 0 && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: roleStr,
                    leftSubTitle: "Roles",
                  },
                ]}
              />
            )}
            {state?.user?.newTags?.length > 0 && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: tagStr,
                    leftSubTitle: "Tags",
                  },
                ]}
              />
            )}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default UserSucess;
